import styled, { css } from 'styled-components';
import { colors, gutter } from '../../../styles/variables';

export const Divider = styled.div`
  margin: ${gutter.small} 0;
  height: 3px;

  ${props => props.color && css`
    background: ${colors.primary.default};
  `}
`;
